import { TableInputCell, TableInputChoice } from "@tellescope/types-models";
import { cn } from "@tellescope/utils";
import { InputTableCell } from "./InputTableCell";
import { Button } from "@tellescope/ui";
import { X } from "lucide-react";

export interface InputTableRowProps {
  fieldId: string;
  value: TableInputCell[];
  onChange: (value: TableInputCell[]) => void;
  onRemove?: () => void;
  removeDisabled?: boolean;
  columnsConfig: TableInputChoice[];
  className?: string;
  autoFocus?: boolean;
  minDateOffsetMs?: number;
  maxDateOffsetMs?: number;
}

export const InputTableRow = ({
  fieldId,
  value,
  onChange,
  onRemove,
  removeDisabled,
  columnsConfig,
  className,
  autoFocus,
  minDateOffsetMs,
  maxDateOffsetMs,
}: InputTableRowProps) => {
  return (
    <div
      className={cn(`grid gap-1`, className)}
      style={{ gridTemplateColumns: `repeat(${columnsConfig.length}, minmax(0, 1fr)) min-content` }}
    >
      {columnsConfig.map((col, i) => (
        <InputTableCell
          key={col.label}
          id={fieldId}
          value={value[i]?.entry ?? ""}
          {...col}
          autoFocus={autoFocus && i === 0}
          minDateOffsetMs={minDateOffsetMs}
          maxDateOffsetMs={maxDateOffsetMs}
          onChange={(newValue) => {
            const padded = columnsConfig.map((column, index) => value[index] ?? { entry: "", label: column.label });
            onChange([...padded.slice(0, i), { entry: newValue, label: col.label }, ...padded.slice(i + 1)]);
          }}
        />
      ))}
      {!!onRemove && (
        <Button variant="ghost" size="icon" onClick={onRemove} disabled={removeDisabled}>
          <X />
        </Button>
      )}
    </div>
  );
};
